module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "visible": _vm.visible,
      "title": "合同确认配置",
      "width": "85%",
      "close-on-click-modal": false,
      "append-to-body": true
    },
    on: {
      "close": _vm.handleClose
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.configList,
      "border": "",
      "size": "mini"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "启用状态",
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-switch', {
          attrs: {
            "active-text": "是",
            "inactive-text": "否",
            "active-value": true,
            "inactive-value": false
          },
          model: {
            value: (row.enabled),
            callback: function($$v) {
              _vm.$set(row, "enabled", $$v)
            },
            expression: "row.enabled"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typeName",
      "label": "合同确认类型",
      "align": "center",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n        " + _vm._s(row.templateName) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "合同确认模版",
      "align": "center",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-link', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(row.templateName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否发起审批",
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-radio-group', {
          model: {
            value: (row.whetherInitiateAudit),
            callback: function($$v) {
              _vm.$set(row, "whetherInitiateAudit", $$v)
            },
            expression: "row.whetherInitiateAudit"
          }
        }, [_c('el-radio', {
          attrs: {
            "label": 1
          }
        }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": 0
          }
        }, [_vm._v("否")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审批方式",
      "align": "center",
      "min-width": "280"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.whetherInitiateAudit) ? [_c('el-radio-group', {
          model: {
            value: (row.auditMethod),
            callback: function($$v) {
              _vm.$set(row, "auditMethod", $$v)
            },
            expression: "row.auditMethod"
          }
        }, [_c('el-radio', {
          attrs: {
            "label": "FEISHU"
          }
        }, [_vm._v("飞书审批")]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "disabled": "",
            "label": "MTDS"
          }
        }, [_vm._v("mtds审单任务")])], 1)] : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审核人设置",
      "align": "center",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', {
          staticStyle: {
            "display": "flex",
            "align-items": "center",
            "gap": "8px"
          }
        }, [(_vm.getReviewerSummary(row)) ? _c('span', {
          staticStyle: {
            "color": "#e6a23c",
            "font-size": "12px"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.getReviewerSummary(row)) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "padding": "0"
          },
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.openReviewerDialog(row)
            }
          }
        }, [_vm._v("\n            添加\n          ")])], 1)]
      }
    }])
  }), _vm._v(" "), (_vm.showDeductionColumn) ? _c('el-table-column', {
    attrs: {
      "label": "是否可关联抵扣",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-radio-group', {
          model: {
            value: (row.canDeduct),
            callback: function($$v) {
              _vm.$set(row, "canDeduct", $$v)
            },
            expression: "row.canDeduct"
          }
        }, [_c('el-radio', {
          attrs: {
            "label": true
          }
        }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": false
          }
        }, [_vm._v("否")])], 1)]
      }
    }], null, false, 3049889224)
  }) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("保 存")])], 1)], 1), _vm._v(" "), _c('reviewer-setting-dialog', {
    attrs: {
      "visible": _vm.reviewerDialogVisible,
      "reviewers": _vm.currentReviewerRow ? _vm.currentReviewerRow.reviewers : []
    },
    on: {
      "close": _vm.handleCloseReviewerDialog,
      "confirm": _vm.handleConfirmReviewer
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f64b6fae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/developerInfo/components/ContractConfirmConfigDialog.vue
// module id = 2426
// module chunks = 68